module.exports = __webpack_public_path__ + "static/img/nobor.232b733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nobor.jpg
// module id = Jptp
// module chunks = 1